var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71596 17.9998V21.4284C7.71596 21.883 7.89657 22.3191 8.21806 22.6405C8.53955 22.962 8.97559 23.1426 9.43025 23.1426H21.4302C21.8849 23.1426 22.3209 22.962 22.6424 22.6405C22.9639 22.3191 23.1445 21.883 23.1445 21.4284V2.57122C23.1445 2.11656 22.9639 1.68053 22.6424 1.35904C22.3209 1.03755 21.8849 0.856934 21.4302 0.856934H9.43025C8.97559 0.856934 8.53955 1.03755 8.21806 1.35904C7.89657 1.68053 7.71596 2.11656 7.71596 2.57122V5.99979M12.8588 11.9998H0.858816M0.858816 11.9998L4.28739 8.57122M0.858816 11.9998L4.28739 15.4284",
    stroke: "#0F2957",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.843db86dabe89a9f095d9c742fd4be28.svg";
export { ForwardRef as ReactComponent };